import React from 'react'

import { Row, Col, Button } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import DKV_CONSTANTS from 'constants/dkv.constants'
import { MANAGED_PAYMENT_ALLOWED_ROLES } from './utils'

/**
 * Allowed Changed plan
 * @param {object} props
 * @param {function} props.onEdit
 * @param {string} props.role
 */
function ButtonChangePlan(props) {
  const { onEdit, role } = props

  if (DKV_CONSTANTS.isDKV) return null
  if (!MANAGED_PAYMENT_ALLOWED_ROLES.includes(role)) return null

  return (
    <Row className='mt-3'>
      <Col>
        <Button color='primary' onClick={onEdit}>
          {I18n.t('dashboard_change-payment-plan')}
        </Button>
      </Col>
    </Row>
  )
}

export default ButtonChangePlan